<template>
  <div class="intro container mx-auto">

    <!-- filter -->
    <div class="d-md-flex align-items-center mb-3 px-4">
      <p class="text-xl font-bold mr-3 mb-2 mb-md-0">回數總覽</p>

      <!-- level -->
      <div class="form-group mr-2 mb-0">
        <select v-model="selectedLevel" class="form-control" id="exampleFormControlSelect1">
          <option :value="null">{{ $route.name === 'GEPT_Overview' ? '初級與中級' : '模擬試題與歷屆考古題'}}</option>
          <option value="初級" v-if="$route.name === 'GEPT_Overview'">初級</option>
          <option value="中級" v-if="$route.name === 'GEPT_Overview'">中級</option>
          <option value="模擬試題" v-if="$route.name === 'quiz_Overview'">模擬試題</option>
          <option value="歷屆考古題" v-if="$route.name === 'quiz_Overview'">歷屆考古題</option>
        </select>
      </div>
      <!-- type -->
      <div class="form-group mb-0" v-if="$route.name === 'GEPT_Overview'">
        <select v-model="selectedType" class="form-control" id="exampleFormControlSelect1">
          <option :value="null">口說與寫作</option>
          <option value="speaking">口說</option>
          <option value="writing">寫作</option>
        </select>
      </div>
    </div>

    <!-- main -->
    <div v-for="(item, index) in menuData" :key="index" class="row"
      :class="{
        'd-none':
          (selectedLevel === '初級' && index === '中級') ||
          (selectedLevel === '中級' && index === '初級') ||
          (selectedLevel === '模擬試題' && index === '歷屆考古題') ||
          (selectedLevel === '歷屆考古題' && index === '模擬試題')
      }">
      <div
        v-for="(child, idx) in item"
        :key="idx"
        class="col-12 p-3"
        :class="{ 'col-lg-6': $route.name !== 'quiz_Overview', 'col-lg-3': (selectedType !== null) || ($route.name === 'quiz_Overview') }">
        <div class="gept_main_bg10 p-3 h-100">

          <p class="text-lg font-bold mb-2">{{ displayExamTitle(index, idx) }}</p>

          <div class="row">
            <div
              class="p-2"
              v-for="(child2, idx2) in child"
              :key="idx2"
              :class="{
                'col-6': $route.name !== 'quiz_Overview',
                'col': $route.name === 'quiz_Overview' && child2.type === 'writing',
                'd-none': (selectedType !== null && child2.type !== selectedType) || ($route.name === 'quiz_Overview' && child2.type === 'speaking'),
                'w-100': selectedType !== null && child2.type === selectedType
              }"
            >
              <div class="bg-white rounded overflow-hidden">

                <!-- 標題 -->
                <p
                  class="text-center text-white py-2 mb-2 font-weight-bold"
                  :class="{
                    'gept_main_bg6': child2.type === 'speaking',
                    'gept_main_bg7': child2.type === 'writing'
                  }"
                >
                  <span v-if="child2.type === 'speaking'">口說練習</span>
                  <span v-if="child2.type === 'writing'">寫作練習</span>
                </p>

                <!-- 練習次數 -->
                <p class="text-center h6 font-weight-bold mb-3">練習次數</p>

                <p
                  class="text-center h5 font-weight-bold mb-2 border-b-1 pb-4 mx-2 mx-lg-3"
                  :class="{
                    'border_main12': child2.type === 'speaking',
                    'border_main13': child2.type === 'writing'
                  }"
                >
                  {{ child2.times }}
                </p>

                <!-- 有效期限 -->
                <p class="text-center font-weight-bold small">
                  <span v-if="!child2.due_at" class="text-muted">尚未開始練習</span>
                  <span
                    v-if="child2.due_at && moment(child2.due_at).isBefore(moment(), 'second')"
                    class="text-muted"
                  >
                    有效期已過，請重新扣點
                  </span>
                  <span
                    v-if="child2.due_at && moment(child2.due_at).isAfter(moment(), 'second')"
                    class="gept_main_color4"
                  >
                    有效時間：{{ moment(child2.due_at).format('YYYY/MM/DD') }}
                  </span>
                </p>

                <!-- 按鈕 -->
                <div class="d-flex mt-3 p-lg-2 small">

                  <!-- 紀錄 -->
                  <a
                    v-if="!child2.record_id"
                    class="d-inline-block w-50 text-center border-1 rounded m-2 py-2 font-weight-bold text-muted"
                    :class="{
                      'border_main12 gept_main_color13': child2.type === 'speaking',
                      'border_main13 gept_main_color14': child2.type === 'writing',
                      'text-gray-500 border-gray-500': !child2.record_id
                    }"
                  >
                    尚無紀錄
                  </a>

                  <router-link
                    v-if="child2.record_id"
                    :to="{ name: $route.name !== 'quiz_Overview' ? 'gept_report_formal' : 'quiz_report_formal', params: { record_id: child2.record_id } }"
                    class="d-inline-block w-50 text-center border-1 rounded m-2 py-2 font-weight-bold"
                    :class="{
                      'border_main12 gept_main_color13': child2.type === 'speaking',
                      'border_main13 gept_main_color14': child2.type === 'writing',
                      'text-gray-500 border-gray-500': !child2.record_id
                    }"
                  >
                    查看紀錄
                  </router-link>

                  <!-- 練習 -->
                  <a v-if="$route.name !== 'quiz_Overview' && (!child2.due_at || moment(child2.due_at).isBefore(moment(), 'second'))"
                    class="d-inline-block w-50 text-center border-1 rounded m-2 py-2 font-weight-bold gept_main_color4 border_main2 pointer"
                    @click="preCheckPoint(child2, index, idx)"
                  >
                    開始練習
                  </a>

                  <a v-if="$route.name !== 'quiz_Overview' && (child2.due_at && moment(child2.due_at).isAfter(moment(), 'second'))"
                    class="d-inline-block w-50 text-center border-1 rounded m-2 py-2 font-weight-bold gept_main_color4 border_main2 pointer"
                    @click="checkAuth(child2, index, idx)"
                  >
                    進入練習
                  </a>
                  <a v-if="$route.name === 'quiz_Overview'" class="mx-auto d-inline-block w-50 text-center border-1 rounded m-2 py-2 font-weight-bold gept_main_color4 border_main2 pointer"
                    @click="preCheckPoint2(child2, index, idx)"
                  >
                    開始練習
                  </a>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import api from '@/store/api'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  export default {
    name: 'Overview',
    metaInfo: {
      title: '回數總覽'
    },
    mixins: [
      formal_examJs
    ],
    data () {
      return {
        menuData: [],
        selectedLevel: null,
        selectedType: null,

        pageSize: 40,
        pagination: {
          currentPage: 1,
          length: 1
        }
      }
    },
    computed: {
      ...mapGetters([
        'remainPoints',
        'authorized'
      ]),
      normalizedMenuData () {
        return Object.fromEntries(
          Object.entries(this.menuData).map(([groupKey, groupValue]) => {

            // 👉 如果是兩層（值是 string / uuid）
            if (typeof Object.values(groupValue)[0] === 'string') {
              return [
                groupKey,
                {
                  全部題目: Object.entries(groupValue).map(([title, uuid]) => ({
                    title,
                    uuid,
                    speaking: null,
                    writing: null
                  }))
                }
              ]
            }

            // 👉 原本就是三層（直接回傳）
            return [groupKey, groupValue]
          })
        )
      },
      returnRouter () {
        return this.$route.name === 'quiz_Overview' ? 'quiz_practice_speaking' : 'formal_exam'
      }
    },
    watch: {
      'authorized' (newVal, oldVal) {
        if (!oldVal && newVal) {
          this.getData()
          this.getMenu()
        }
      }
    },
    mounted () {
      this.getData()
      // this.$route.name === 'GEPT_Overview' ? this.getData() : this.getData2()

      this.setSelectVal()
    },
    methods: {
      setSelectVal () {
        if (this.$route.query.level) {
          this.selectedLevel = this.$route.query.level
          // self.selectedType = self.$route.query.type
          // if (this.$route.name === 'GEPT_Overview') {
          //   this.$router.push({ name: 'GEPT_Overview' })
          // } else {
          //   this.$router.push({ name: 'quiz_Overview' })
          // }
        }
      },

      getData () {
        let self = this
        let path = `/assessments/gept/categories/records?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`
        if (this.$route.name === 'quiz_Overview') {
          path = `https://ll-livespeaking.liveabc.com/api/assessments/highschool_writing/categories/records?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`
        }
        self.$store.dispatch('isLoading', true)

        api.get(path)
        .then((res) => {
          self.menuData = res.data
          self.$store.dispatch('isLoading', false)
        })
        .catch(() => {
          self.$store.dispatch('isLoading', false)
        })
      },
      getPracticeType (item) {
        return this.$route.name === 'quiz_Overview' ? 'writing' : item.type
      },

      displayExamTitle (level, title, includeGeptPrefix = false) {
        const levelText = String(level || '').trim()
        const titleText = String(title || '').trim()
        const titleParts = []

        if (includeGeptPrefix && this.$route.name !== 'quiz_Overview') {
          titleParts.push('GEPT')
        }

        if (this.$route.name === 'quiz_Overview' && levelText && titleText.startsWith(levelText)) {
          titleParts.push(titleText)
        } else {
          titleParts.push(levelText, titleText)
        }

        return titleParts.filter(Boolean).join(' ')
      },

      goToExam (item, recordId) {
        this.$router.push({
          name: this.returnRouter,
          params: {
            select_id: item.id,
            practice_type: this.getPracticeType(item)
          },
          query: { record_id: recordId }
        })
      },

      async checkAuth (item, index, idx) {
        try {
          const result = await this.post_records_purchase(item.id, this.getPracticeType(item))
          if (result && result.record_id) {
            this.goToExam(item, result.record_id)
            return
          }

          await this.preCheckPoint(item, index, idx, result)
        } catch (err) {
          console.log(err)
          this.rejectAlert(err && err.response && err.response.data && err.response.data.msg)
        }
      },

      async preCheckPoint (item, index, idx, purchaseResult = null) {
        try {
          this.$store.dispatch('isLoading', true)
          await this.$store.dispatch('getRemainPoints')

          const result = purchaseResult || await this.post_records_purchase(item.id, this.getPracticeType(item))
          this.$store.dispatch('isLoading', false)

          if (result && result.record_id) {
            this.goToExam(item, result.record_id)
            return
          }

          const points = this.getPurchasePoints(result)
          if (points !== null && this.remainPoints >= points) {
            this.confirmPurchase(item, index, idx, result)
            return
          }

          this.rejectAlert(result && result.msg)
        } catch (err) {
          console.log(err)
          this.$store.dispatch('isLoading', false)
          this.rejectAlert(err && err.response && err.response.data && err.response.data.msg)
        }
      },

      preCheckPoint2 (item, index, idx) {
        this.preCheckPoint(item, index, idx)
      },

      async startPurchasedExam (item) {
        try {
          this.$store.dispatch('isLoading', true)
          const response = await api.post('/assessments/records/?purchase=yes', {
            id: item.id,
            type: this.getPracticeType(item)
          })
          this.$store.dispatch('isLoading', false)
          this.$store.dispatch('getRemainPoints')

          const recordId = response.data && response.data.record_id
          if (recordId) {
            this.goToExam(item, recordId)
            return response.data
          }

          return {
            error: true,
            msg: '無法取得考試紀錄，請稍後再試'
          }
        } catch (err) {
          this.$store.dispatch('isLoading', false)
          return {
            error: true,
            msg: err && err.response && err.response.data && err.response.data.msg
              ? err.response.data.msg
              : '發生錯誤'
          }
        }
      },

      getPurchasePoints (purchaseInfo = {}) {
        if (!purchaseInfo) return null
        if (!Object.prototype.hasOwnProperty.call(purchaseInfo, 'points')) return null

        const points = Number(purchaseInfo.points)
        return Number.isFinite(points) ? points : null
      },

      async confirmPurchase (item, level, index, result = {}) {
        let self = this
        const points = this.getPurchasePoints(result)
        let pointN = points !== null ? points : 0

        let type = this.getPracticeType(item) === 'writing' ? '寫作練習' : '口說練習'
        let examTitle = this.displayExamTitle(level, index, true)
        let html = `<p class="text-lg text-black mb-3 font-semibold">請問是否要開始</p>
          <p class="text-xl gept_main_color4 mb-3 font-semibold">${examTitle}<span class=" rounded-lg p-1 ml-2 gept_main_bg6 text-white text-lg">${type}</span></p>
          <p class="text-lg text-black mb-5 font-semibold">按下確認後，將扣除${pointN}點。</p>
          <div class="gept_main_bg11 text-lg p-3 max-w-sm mx-auto text-black font-normal">
            <div class="d-flex justify-content-center border-b border_main5 p-1">
              <p>目前總點數：</p>
              <p>${self.remainPoints} 點</p>
            </div>
            <div class="d-flex justify-content-center border-b border_main5 p-1">
              <p>需扣除：</p>
              <p>${pointN} 點</p>
            </div>
            <div class="d-flex justify-content-center p-1">
              <p>扣除後點數：</p>
              <p>${self.remainPoints - pointN} 點</p>
            </div>
          </div>`

          self.$swal.fire({
            html: html,
            showCloseButton: false,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: '扣點說明',
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-100',
              header: 'justify-content-center align-items-center gept_main_bg py-4',
              closeButton: 'position-absolute right-0 top-0',
              htmlContainer: 'my-4 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2',
              denyButton: 'btn-deny-gept order-1'
            }
          })
        .then(async(swalResult) => {
            if (swalResult.isConfirmed === true) {
              const startResult = await self.startPurchasedExam(item)
              if (startResult && startResult.error) {
                self.rejectAlert(startResult.msg, 'Notice')
              }
            }
          }
        )
      },

      rejectAlert (msg, title = '') {
        let self = this
        const alertTitle = title || (msg ? 'error' : '點數餘額不足')
        const storeLink = alertTitle === '點數餘額不足'
          ? '<a href="https://store.liveabc.com/products/digital?category=221" target="_blank" class="text-xl gept_main_bg5 text-white mb-3 font-semibold pointer px-3 py-2 d-inline-block">購買網址</a>'
          : ''

        let html = `<p class="text-lg text-black mb-5 font-semibold">${msg ? msg : '點數餘額不足支付本課程，請於LiveABC官網加購'}</p>
          ${storeLink}`

          self.$swal.fire({
            html: html,
            showCloseButton: true,
            showDenyButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            confirmButtonText: `確認`,
            denyButtonText: `返回`,
            title: alertTitle,
            customClass: {
              title: 'text-white text-xl m-0',
              container: '',
              popup: 'p-0 max-w-2xl w-100',
              header: 'justify-content-center align-items-center gept_main_bg py-4',
              closeButton: 'position-absolute right-0 top-0',
              htmlContainer: 'my-6 text-xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit-gept order-2',
              denyButton: 'btn-deny-gept order-1'
            }
          })
      }
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.border-b-1 {
  border-bottom: 1px solid #a0aec0;
}
.text-gray-500 {
    --text-opacity: 1 !important;
    color: #a0aec0 !important;
    color: rgba(160, 174, 192, var(--text-opacity)) !important;
}
.border-gray-500 {
    --border-opacity: 1 !important;
    border-color: #a0aec0 !important;
    border-color: rgba(160, 174, 192, var(--border-opacity)) !important;
}
.intro {
  .goal {
    background-image: url('~@/assets/image/gept/259.png');
    background-repeat: no-repeat;
    background-position: bottom right;
  }
  .list_item {

    .title_bg {
      background: #2D9AA9;
      .space {
        width: 30px;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #ffffff 50%, #ffffff 100%);
      }
    }
    .title_bg_write {
      background: #6c7ccc;
      .space {
        width: 30px;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #ffffff 50%, #ffffff 100%);
      }
    }
    ul {
      li {
        .list_item_child {
          border-left-width: 10px;
          border-color: #2D9AA9;
        }
        .list_item_child_write {
          border-left-width: 10px;
          border-color: #6c7ccc;
        }
        &:hover {
          background: rgba(255, 254, 224, 1) !important;
        }
      }
    }
  }
}


</style>
